<!-- 不同渠道相关的推广链接下拉搜索 -->
<template>
<div>
	<a-select
		:mode="mode_type == 'dan'?'':'multiple'"
		:class="[ page_type == 'effectB'? 'page-true':'page-false', ]"
		placeholder="请选择"
		:notFoundContent="no_found_text"
		:filter-option="false"
		@change="handleChangeS"
		:getPopupContainer="getsPopupContainer" 
		@popupScroll="popupScrollHandle" 
		showSearch
		:allowClear="page_type == 'gzhFans'?false : true"
		@search="selectZhSearch"
		:not-found-content="s_fetching ? undefined : null" 
		@blur="zhBlur" 
		:value="select_value"
	  >
		<a-spin v-if="s_fetching" slot="notFoundContent" size="small" />
		
		<a-select-option v-for="(item,index) in showFilterData" :key="item.id" :value="item.id" :title="item.text">
		  {{item.text}}
		</a-select-option>
		<a-select-option v-if="loading_more_hint" value="-0-">
			<div style="color:rgb(98, 168, 234)">加载更多中...</div>
			
		</a-select-option>
	</a-select>
	
</div>
</template>

<script>
import { effectReceiveChannel } from '@/request/api'
export default {
	name: 'searchLinkSelect_',
	props: ['page_type','mode_type','no_found_text'],
	data(){
		return {
			select_value: [], // 选择的广告账户
			showFilterData: [], // 选择广告账户
			s_page: 1,
			s_limit: 50,
			s_adv_name: "", // 下拉选择框的搜索字段
			s_fetching: false, // 用于控制提示
			showFilterBlur: [], // 保存一份，用于失去焦点后，回复原来的数值
			loading_more_control: true, // 上拉加载更多控制
			loading_more_hint: false, // 上拉加载更多的提示
			
			r_type: "", // 1-H5公众号书城，2快应用书城，3短剧渠道
			r_q: "",
		}
	},
	mounted(){
		// console.log("page-type",this.page_type)
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		getSelectData(e,type,handle){
			let that = this
			console.log("e,type",e,type);
			if(handle == 'clear'){
				that.select_value = undefined
			}
			
			that.r_type = type
			that.r_q = e
			
			if(!e && type == 2){ // 快应用推广链接，当没有渠道ID时，就不进行请求了，并且把内容清空
				console.log("快应用推广链接，当没有渠道ID时，就不进行请求了");
				that.showFilterData = []
				that.showFilterBlur = []
				that.select_value = []
				return
			}
			
			effectReceiveChannel({
				page: 1,
				limit: that.s_limit,
				
				q: e, // 不同渠道的渠道ID
				type: that.r_type,
			}).then(res=>{
				console.log("获取公众号",res)
				// if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.showFilterData = res.data || []
					
					// that.showFilterData = res.data.slice(that.s_page, that.s_limit)
					// that.showFilterSearch = res.data
					that.showFilterBlur = res.data || []
				// }
				// else {
				// 	that.$message.error(`错误：${res.data.msg}`);
				// }
			})
			
		},
		clearValue(){
			this.select_value = undefined
		},
		
		handleChangeS(value) {
			console.log("handleChangeS",value);
			if(this.mode_type == 'dan'){
				this.select_value = value
				this.$emit('handleChangeSelect', value)
				return
			}
			
			if(value.indexOf('-1') > -1){
				// console.log("全选");
				let i_data = []
				// console.log("this.showFilterSearch",this.showFilterSearch.length);
				
				this.showFilterSearch.forEach(res=>{
					i_data.push(res.id)
				})
				// 避免已选择的内容被替换掉，所以这里是合并
				let z_data = this.select_value.concat(i_data)
				// 数组去重
				this.select_value = Array.from(new Set(z_data))
					
				
				this.$emit('handleChangeSelect', this.select_value)
			}
			else {
				this.select_value = value
				this.$emit('handleChangeSelect', value)
			}
		},
		
		popupScrollHandle(e){ // 上拉触底加载更多
			// console.log("上拉触底加载更多",e);
			// console.log(e.target.scrollTop);
			// console.log(e.target.scrollHeight - e.target.scrollTop);
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_more_control){ // 节流，保证这期间只执行一次
					this.loading_more_hint = true
					this.loading_more_control = false
					let that = this
					that.s_page = that.s_page + 1
					console.log("上拉触底加载更多");
					effectReceiveChannel({
						page: that.s_page,
						limit: that.s_limit,
						name: that.s_adv_name,
						
						q: that.r_q,
						type: that.r_type,
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.showFilterData 
						that.loading_more_hint = false
						that.showFilterData = data.concat(res.data) 
						that.s_fetching = false
						that.loading_more_control = true
					})
				}
			}
		},
		// 选择框搜索-选择广告账户
		selectZhSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.showFilterData = []
			that.s_fetching = true
			that.s_adv_name = e
			
			effectReceiveChannel({
				page: 1,
				limit: that.s_limit,
				
				name: e,
				q: that.r_q,
				type: that.r_type,
			}).then(res=>{
				console.log('选择',res);
				that.s_page = 1
				that.showFilterData = res.data
				that.s_fetching = false
			})
		},
		// 失去焦点
		zhBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.s_page = 1
			that.s_adv_name = '' // 清空
			that.showFilterData = that.showFilterBlur 
		},
	}
}
</script>

<style scoped>
.page-true {
	width: 100%;
}
.page-false {
	min-width: 300px;
	max-width: 1300px;
}
</style>